<template>
	<div class="container">
		<!--页面开始-->
		<div class="main">
			<!--到顶部-->
			<go-top></go-top>
			<!--到顶部-->
			<div class="result_box">
				<div class="img_box">
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/img_one.png')"
					   @click.stop.prevent="showBig(0)"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/img_two.png')"
					   @click.stop.prevent="showBig(1)"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/img_three.png')"
					   @click.stop.prevent="showBig(2)"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/img_four.png')"
					   @click.stop.prevent="showBig(3)"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
				</div>
			</div>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
import { ImagePreview } from "vant";
import goTop from '@/components/goTop';
export default {
	components:{
		'go-top': goTop
	},
	data() {
		return {
			imgList: [
				require('@/assets/img/img_one.png'),
				require('@/assets/img/img_two.png'),
				require('@/assets/img/img_three.png'),
				require('@/assets/img/img_four.png'),
			]
		}
	},
	created(){
		this.$toast.loading({
			duration: 0,
		});
	},
	mounted() {
		this.$toast.clear();
	},
	watch: {
		//
	},
	methods: {
		//展示大图
		showBig(value) {
			let that = this;
			ImagePreview({
			  images: that.imgList,
			  startPosition: value,
			});
		}
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
*{color:#333333;}
.main{padding:0.4rem;}
.main div{padding-bottom: 0;}
.img_box img{width: 100%;height: auto;}
</style>
